// extracted by css-extract-rspack-plugin
export default {"cls1":"IconCell-cls1_NI_","cls2":"IconCell-cls2_jds IconCell-cls1_NI_"};